import { DeleteIcon, EditIcon } from '@sketchnote/icons';
import { MoreActionMenu } from '@sketchnote/shared-components';
import * as React from 'react';

export interface SprintActionProps {
  onClick?: (val: any, event: any) => void | undefined;
  isDefaultSection?: boolean;
}

export const SprintAction = ({ onClick, isDefaultSection }: SprintActionProps) => {
  return (
    <MoreActionMenu
      usePortal
      onClickMenuItem={onClick}
      classNames={{
        menuWrap: 'rounded-lg shadow-sm',
      }}
      menuItems={[
        {
          label: (
            <div className="flex font-regular text-gray-999 text-sm ">
              <DeleteIcon wrapperClass="mt-4 text-gray-500" />
              &nbsp;&nbsp; Delete sprint
            </div>
          ),
          value: 'delete',
          isActive: isDefaultSection,
        },
        {
          label: (
            <div className="flex font-regular text-gray-999 text-sm ">
              <EditIcon wrapperClass="mt-4 text-gray-500" />
              &nbsp;&nbsp; Edit sprint
            </div>
          ),
          value: 'edit',
          isActive: isDefaultSection,
        },
      ]}
    />
  );
};
